import _ from 'lodash'
export const mentorship = (state) => _.get(state, 'mentorship', {})